export default "__VITE_ASSET__66a15b65__"